import classNames from 'classnames';

interface AddWaypointButtonProps {
    onClick: () => void;
}

export const AddWaypointButton = ({ onClick }: AddWaypointButtonProps) => {
    const wrapperClassNames = classNames(
        'display-flex',
        'gap-5',
        'align-items-center',
        'height-10',
        'opacity-0',
        'hover-opacity-100',
        'cursor-pointer',
        'padding-x-10'
    );

    const dividerWrapperClassNames = classNames('margin-0', 'border-width-1', 'border-color-light');

    return (
        <div className={wrapperClassNames} onClick={onClick}>
            <div style={{ flexGrow: 1 }}>
                <hr className={dividerWrapperClassNames} />
            </div>
            <div className='display-flex align-items-center'>
                <span className='rioglyph rioglyph-plus-light text-color-dark' />
            </div>
            <div style={{ flexGrow: 1 }}>
                <hr className={dividerWrapperClassNames} />
            </div>
        </div>
    );
};
